import { SortDirectionEnum } from './SortDirectionEnum';

const defaultInvitationsState = {
  activeReview: false,
  counts: {
    expiredInvitations: 0,
    pendingInvitations: 0
  },
  byId: {},
  filter: '',
  sort: {
    email: null,
    role: null
  },
  selectedInvitationId: '',
  startInvitation: false
};

export const invitations = (state = defaultInvitationsState, action) => {
  switch (action.type) {
    case 'CANCEL_INVITATION_PROCESS': {
      return {
        ...state,
        startInvitation: false
      };
    }
    case 'DESELECT_INVITATION': {
      return {
        ...state,
        selectedInvitationId: ''
      };
    }
    case 'FILTER_INVITATIONS': {
      return {
        ...state,
        filter: action.payload
      };
    }
    case 'GET_INVITATIONS':
    case 'GET_INVITATION_COUNTS':
    case 'ISSUE_INVITATION': {
      return {
        ...state,
        ...action.payload
      };
    }
    case 'RESET_INVITATIONS': {
      return {
        ...state,
        byId: {}
      };
    }
    case 'SELECT_INVITATION': {
      return {
        ...state,
        selectedInvitationId: action.payload
      };
    }
    case 'SELECT_INVITATIONS': {
      return {
        ...state,
        activeReview: true
      };
    }
    case 'SELECT_USERS':
    case 'SELECT_DEACTIVATED': {
      return {
        ...state,
        activeReview: false,
        filter: '',
        sort: {
          email: null,
          role: null
        }
      };
    }
    case 'SORT_INVITATIONS': {
      return {
        ...state,
        sort: {
          ...state.sort,
          ...action.payload
        }
      };
    }
    case 'START_INVITATION_PROCESS': {
      return {
        ...state,
        startInvitation: true
      };
    }
    default:
      return state;
  }
};

export const invitationsSelectors = {
  activeReview: state => state.invitations.activeReview,
  filter: state => state.invitations.filter,
  invitationsFilteredAndSorted: state => {
    let invitationsByIdList = Object.values(state.invitations.byId);

    if (state.invitations.filter) {
      invitationsByIdList = invitationsByIdList.filter(invitation =>
        `${invitation.email.toLowerCase()} ${invitation.role.toLowerCase()}`.includes(
          state.invitations.filter.toLowerCase()
        )
      );
    }

    Object.entries(state.invitations.sort).forEach(([field, direction]) => {
      if (direction) {
        invitationsByIdList.sort((a, b) => {
          const aField = a[field].toLowerCase();
          const bField = b[field].toLowerCase();

          if (aField > bField) {
            return direction === SortDirectionEnum.Asc ? 1 : -1;
          }

          if (aField < bField) {
            return direction === SortDirectionEnum.Asc ? -1 : 1;
          }

          return 0;
        });
      }
    });

    return invitationsByIdList;
  },
  selectedInvitationEmail: state => state.invitations.byId[state.invitations.selectedInvitationId]?.email,
  selectedInvitationId: state => state.invitations.selectedInvitationId,
  selectedInvitationDepartments: state =>
    state.invitations.byId[state.invitations.selectedInvitationId]?.departments || [],
  selectedInvitationRole: state => state.invitations.byId[state.invitations.selectedInvitationId]?.role,
  sort: state => state.invitations.sort,
  sortEntries: state => Object.entries(state.invitations.sort),
  startInvitation: state => state.invitations.startInvitation,
  pendingInvitationsCount: state => state.invitations.counts.pendingInvitations,
  expiredInvitationsCount: state => state.invitations.counts.expiredInvitations
};
